export default [
  { url: '/espaces/', label: 'Espaces' },
  { url: '/etudes/', label: 'Études' },
  { url: '/recherche/', label: 'Recherche' },
  { url: '/enseignement/', label: 'Enseignement' },
  { url: '/engagements/', label: 'Engagements' },
  { url: '/tests/', label: 'Tests' },
]